
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.152 18.941a1.006 1.006 0 01-.724.31H2.508a2 2 0 110-4h11.217a1 1 0 00.731-.318l5.517-4.844a2.031 2.031 0 012.96 2.783l-6.781 6.069zm-11.644 4.31l3-4m8.958 4l-3-4m-6.958-17.5v-1m3.155 2.32l.707-.708m.638 3.888h1M9.663 9.435l.707.707m-3.862.609v1M3.299 9.435l-.707.707m-.584-3.891h-1m2.291-3.18l-.707-.708m3.916 6.406a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    